import { createFunnelPageConfig, LandingPageKind, templateSection, type LandingTemplate } from "../../template";
import {
  resetBonusesProps,
  resetCheckoutProps,
  resetFaqProps,
  resetGuaranteeProps,
  resetHeaderProps,
  resetHeroProps,
  resetLandingEffectsProps,
  resetLongTermProps,
  resetOfferProps,
  resetPainProps,
  resetRulesProps,
  resetSolutionProps,
  resetStackProps,
  resetStickyCtaProps,
  resetTestimonialProps,
  resetThankYouProps,
  resetTimelineProps,
} from "./content";

const landingConfig = createFunnelPageConfig({
  title: "Reset Metabolizmu 40+ | Program Hollywood",
  description:
    "Schudnij 3 kg w 6 tygodni. Albo oddamy Ci pieniądze. Reset Metabolizmu 40+ dla kobiet, którym diety przestały działać. Dietetyk 1:1, dieta w 25 minut, trening 90-60-90 w domu.",
  ogImage: "/assets/main.jpeg",
  pageName: "hollywood-reset-start",
  shell: "landing",
  accentColor: "gold",
  backgroundClassName: "bg-[#f3f3f3]",
  sections: [
    templateSection("reset-effects", "resetLandingEffects", resetLandingEffectsProps),
    templateSection("reset-header", "resetHeader", resetHeaderProps),
    templateSection("reset-hero", "resetHero", resetHeroProps, { trackingName: "hero" }),
    templateSection("reset-transformations", "transformationCarousel", {}, { trackingName: "transformations" }),
    templateSection("reset-pain", "resetPain", resetPainProps, { trackingName: "pain" }),
    templateSection("reset-rules", "resetRules", resetRulesProps, { trackingName: "rules" }),
    templateSection("reset-solution", "resetSolution", resetSolutionProps, { trackingName: "solution" }),
    templateSection("reset-stack", "resetStack", resetStackProps, { trackingName: "stack" }),
    templateSection("reset-bonuses", "resetBonuses", resetBonusesProps, { trackingName: "bonuses" }),
    templateSection("reset-guarantee", "resetGuarantee", resetGuaranteeProps, { trackingName: "guarantee" }),
    templateSection("reset-marta", "resetTestimonial", resetTestimonialProps, { trackingName: "marta" }),
    templateSection("reset-long-term", "resetLongTerm", resetLongTermProps, { trackingName: "long_term" }),
    templateSection("reset-timeline", "resetTimeline", resetTimelineProps, { trackingName: "timeline" }),
    templateSection("reset-offer", "resetOffer", resetOfferProps, { trackingName: "final" }),
    templateSection("reset-faq", "resetFaq", resetFaqProps, { trackingName: "faq" }),
    templateSection("reset-footer", "hollywoodFooter", { variant: "lean" }),
    templateSection("reset-sticky-cta", "resetStickyCta", resetStickyCtaProps),
  ],
});

export const resetTemplates: LandingTemplate[] = [
  {
    key: "hollywood-reset-landing",
    name: "Hollywood Reset - landing",
    kind: LandingPageKind.Landing,
    sourceRoute: "/oferta/hollywood-reset/start",
    config: {
      ...landingConfig,
      seo: {
        ...landingConfig.seo,
        facebookDomainVerification: "jdtjx4q9c5kqlid5h5qb3ayhnixrr1",
        favicon: "/favicon.png",
      },
    },
  },
  {
    key: "hollywood-reset-checkout",
    name: "Hollywood Reset - checkout",
    kind: LandingPageKind.Checkout,
    sourceRoute: "/oferta/hollywood-reset/checkout",
    config: createFunnelPageConfig({
      title: resetCheckoutProps.seoTitle,
      pageName: "hollywood-reset-checkout",
      shell: "embedding",
      accentColor: "ruby",
      backgroundClassName: "",
      sections: [templateSection("reset-checkout", "resetCheckout", resetCheckoutProps)],
    }),
  },
  {
    key: "hollywood-reset-dziekujemy",
    name: "Hollywood Reset - podziękowanie",
    kind: LandingPageKind.ThankYou,
    sourceRoute: "/oferta/hollywood-reset/ty",
    config: createFunnelPageConfig({
      title: "Dziękujemy za zakup | Program Hollywood",
      pageName: "hollywood-reset-ty",
      shell: "embedding",
      accentColor: "gold",
      backgroundClassName: "",
      sections: [templateSection("reset-thank-you", "resetThankYou", resetThankYouProps)],
    }),
  },
];
